import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectSidebarCollapsed } from '@stores/ui';
import { AppSidebarComponent } from '../sidebar/app-sidebar.component';
import { AppHeaderComponent } from '../header/app-header.component';
import { ShellStateService } from './shell-state.service';

@Component({
  selector: 'mtm-app-shell',
  standalone: true,
  imports: [RouterOutlet, AppSidebarComponent, AppHeaderComponent],
  templateUrl: './app-shell.component.html',
  styleUrl: './app-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '(document:keydown.escape)': 'shell.mobileNavOpen.set(false)' },
})
export class AppShellComponent {
  private readonly store = inject(Store);
  readonly shell = inject(ShellStateService);

  readonly collapsed = this.store.selectSignal(selectSidebarCollapsed);
}
